import { createRoot } from 'react-dom/client';
import App from './components/app/App';

createRoot(document.getElementById("root"))
    .render(<App />);